import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/burun-dolgusu-ile-ameliyatsiz-burun-duzeltme/page.tsx");
